// extracted by mini-css-extract-plugin
export var actionButton = "_n4-0";
export var actionMenuContainer = "_n4-i";
export var bubble = "_n4-2";
export var bubbleActionMenu = "_n4-j";
export var bubbleContext = "_n4-6";
export var bubbleItems = "_n4-7";
export var customer = "_n4-3";
export var divider = "_n4-8";
export var fileList = "_n4-9";
export var hiddenComment = "_n4-o";
export var infoAbove = "_n4-a";
export var internal = "_n4-4";
export var lightActionButton = "_n4-1";
export var link = "_n4-b";
export var merchant = "_n4-5";
export var message = "_n4-c";
export var profilePicture = "_n4-e";
export var quillToolbarContainer = "_n4-f";
export var senderDate = "_n4-g";
export var senderDateCustomer = "_n4-h";
export var senderName = "_n4-d";
export var time = "_n4-k";
export var uploadedImage = "_n4-l";
export var username = "_n4-m";
export var xsmall = "_n4-n";